// Hooks / Node modules / Styles
import { Form, Input, Button } from "elseware-ui";
import * as Yup from "yup";
import { FaGoogle, FaLinkedin } from "react-icons/fa";

// Reducers / Actions

// Utils / Functions

// Components
import DefaultLayout from "src/layout/standard/primary/DefaultLayout";

// Sub-Components

// Authentication Handlers (Replace with actual implementations)
const handleGoogleLogin = () => {
  console.log("Google Login Clicked");
  // Implement Google OAuth logic
};

const handleLinkedInLogin = () => {
  console.log("LinkedIn Login Clicked");
  // Implement LinkedIn OAuth logic
};

// Data / Images / Icons
const initialValues = {
  email: "",
  password: "",
};

const validations = Yup.object({
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),
  password: Yup.string().required("Password is required"),
});

const onSubmit = (values) => {
  console.log("Login Form Submitted:", values);
  // Implement authentication logic here
};

function P_Login() {
  return (
    <DefaultLayout>
      <div className="max-w-md mx-auto p-10 local-theme-bg-md local-theme-border-md shadow-md rounded-md">
        <h2 className="text-2xl font-bold mb-3 local-theme-text-md text-center">
          Login
        </h2>
        <div className="local-theme-text-sm text-center pb-6 text-sm w-4/5 mx-auto">
          Sign in to manage your projects, collaborate, and explore exclusive
          content.
        </div>

        <Form
          enableReinitialize={true}
          initialValues={initialValues}
          validationSchema={validations}
          onSubmit={onSubmit}
        >
          <div className="flex flex-col gap-4">
            <Input type="email" name="email" placeholder="Your Email" />
            <Input
              type="password"
              name="password"
              placeholder="Your Password"
            />
            <Button
              type="submit"
              text="Login"
              variant="success"
              size="lg"
              shape="softRoundedSquare"
              block
            />
          </div>
        </Form>

        <div className="text-center text-gray-500 my-4">Or</div>

        {/* Social Login Buttons */}
        <div className="flex flex-col gap-3">
          <Button
            text="Login with Google"
            icon={<FaGoogle />}
            variant="default"
            size="lg"
            shape="softRoundedSquare"
            block
            onClick={handleGoogleLogin}
          />
          <Button
            text="Login with LinkedIn"
            icon={<FaLinkedin />}
            variant="default"
            size="lg"
            shape="softRoundedSquare"
            block
            onClick={handleLinkedInLogin}
          />
        </div>

        <div className="text-center text-sm mt-4">
          Don't have an account?{" "}
          <a href="/signup" className="text-blue-600">
            Sign up
          </a>
        </div>
      </div>
    </DefaultLayout>
  );
}

export default P_Login;
